import { render } from "./upload-button.vue?vue&type=template&id=11f6ba58&ts=true"
import script from "./upload-button.ts?vue&type=script&lang=ts&external"
export * from "./upload-button.ts?vue&type=script&lang=ts&external"

import "./upload-button.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__